import { useFormikContext } from "formik";
import { isNotEmpty } from "neetocist";
import { Select, Input } from "neetoui/formik";
import { useTranslation } from "react-i18next";

import { getReplyToFieldLabelProps } from "./utils";

const ReplyToField = ({ options = [], popoverProps = {} }) => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext();

  const isDropdownField = isNotEmpty(options);
  const labelProps = getReplyToFieldLabelProps({ popoverProps });

  if (isDropdownField) {
    return (
      <Select
        {...{ labelProps, options }}
        isClearable
        className="w-full"
        data-testid="reply-to-select-field"
        label={t("neetoMolecules.emailForm.labels.replyTo")}
        name="replyTo"
        onChange={data => setFieldValue("replyTo", data?.value ?? "")}
      />
    );
  }

  return (
    <Input
      {...{ labelProps }}
      autoFocus
      nakedInput
      required
      className="w-full"
      data-testid="reply-to-input-field"
      label={t("neetoMolecules.emailForm.labels.replyTo")}
      name="replyTo"
      placeholder={t("neetoMolecules.emailForm.placeholders.emailPlaceholder")}
      size="large"
      onChange={event =>
        setFieldValue("replyTo", event.target.value?.toLowerCase())
      }
    />
  );
};

export default ReplyToField;
